import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M18 5C18.551 5 19 5.449 19 6V20C19 20.551 18.551 21 18 21H6C5.449 21 5 20.551 5 20V6C5 5.449 5.449 5 6 5H7.863C7.88 6.088 8.771 6.968 9.863 6.968H14.137C15.229 6.968 16.12 6.088 16.137 5H18ZM18 4H15.137V4.968C15.137 5.518 14.687 5.968 14.137 5.968H9.863C9.313 5.968 8.863 5.518 8.863 4.968V4H6C4.9 4 4 4.9 4 6V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V6C20 4.9 19.1 4 18 4Z"
      fill="currentColor"
    />
    <path
      d="M12.667 3V4H15.137V5.968H8.86304V4H11.333V3H12.667ZM12.667 2H11.333C10.783 2 10.333 2.45 10.333 3H8.86304C8.31304 3 7.86304 3.45 7.86304 4V5.968C7.86304 6.518 8.31304 6.968 8.86304 6.968H15.137C15.687 6.968 16.137 6.518 16.137 5.968V4C16.137 3.45 15.687 3 15.137 3H13.667C13.667 2.45 13.217 2 12.667 2Z"
      fill="currentColor"
    />
    <path
      d="M11.024 17.098L10.469 16.559C10.462 16.552 9.71701 15.828 8.97501 15.097C7.35101 13.496 7.33301 13.447 7.25801 13.242C7.10701 12.827 7.32201 12.368 7.73701 12.217C8.08801 12.089 8.47101 12.223 8.67201 12.519C8.86901 12.745 9.92901 13.797 11.027 14.87C11.93 13.989 13.792 12.159 15.533 10.347C15.839 10.028 16.346 10.018 16.664 10.325C16.982 10.632 16.993 11.138 16.686 11.456C14.26 13.98 11.607 16.537 11.58 16.562L11.023 17.098H11.024ZM8.76201 12.695V12.696V12.695Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'ToDo');

export default Icon;
